import React from 'react'
import useStores from '../container/hooks/useStores'
import {
  Button,
  Dialog,
  DialogContent,
  Box,
  DialogActions,
  DialogTitle
} from '@material-ui/core'
import SelectFormField from './form/SelectFormField'
import LoadableButton from './form/LoadableButton'

export default function CloseSaleDialogButton() {
  const { seo, sale } = useStores('seo', 'sale')
  console.log({ seo, sale })
  const status = seo.status || {}

  const [open, setOpen] = React.useState(false)
  const [form, setForm] = React.useState({})
  const [loading, setLoading] = React.useState(false)

  const handleToggle = () => {
    setOpen(!open)
  }

  const handleChange = event => {
    setForm({ ...form, [event.target.name]: event.target.value })
  }

  const handleSubmit = async () => {
    setLoading(true)
    // if (sale.sale.assignTo === currentUser.username && !form.assignTo) {
    //   enqueueSnackbar(`Необходимо выбрать менеджера`, { variant: 'error'})
    // }
    if ([6, '6'].includes(status.code)) {
      if (form.department) {
        await seo.assignDepartment(form.department)
      } else {
        await seo.closeTicket()
      }
    }
    await sale.closeSale(form.assignTo)
    await seo.getStatus()
    setLoading(false)
    handleToggle()
  }

  React.useEffect(() => {
    if (open) {
      seo.getDepartmentsList()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])

  console.log({ status: seo.status })

  return (
    <>
      <Button variant="contained" color="default" onClick={handleToggle}>
        Завершить работу
      </Button>
      <Dialog open={open} onClose={handleToggle}>
        <DialogTitle>Завершить работу</DialogTitle>
        <DialogContent>
          <Box px={1} mb={3}>
            {[6, '6'].includes(status.code) && (
              <Box my={1} maxWidth={300}>
                <SelectFormField
                  fullWidth
                  name="department"
                  variant="outlined"
                  options={seo.departmentsList}
                  value={form.department}
                  valueKey="Id"
                  labelKey="Title"
                  label="Перевести"
                  onChange={handleChange}
                />
              </Box>
            )}
            {/* <Box my={1} maxWidth={300}>
              <UserSelectTextField
                label='Назначить менджера'
                roleCode='MANAGER'
                projectCode='CS'
                branchCode={'ALA_BESAGASH'}
                value={form.assignTo && form.assignTo.username}
                onChange={handleChangeUser('assignTo')}
              />
            </Box> */}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" size="small" onClick={handleToggle}>
            Закрыть
          </Button>
          {form.department ? (
            <LoadableButton
              loading={loading}
              variant="contained"
              color="primary"
              size="small"
              onClick={handleSubmit}
            >
              Перевести
            </LoadableButton>
          ) : (
            <LoadableButton
              loading={loading}
              variant="contained"
              color="secondary"
              size="small"
              onClick={handleSubmit}
            >
              Завершить
            </LoadableButton>
          )}
        </DialogActions>
      </Dialog>
    </>
  )
}
